import React, { useEffect, useState } from "react";

import {
    MapPin,
    Bike,
    Clock3,
    Package,
    IndianRupee,
    Store,
} from "lucide-react";

import "./LiveOrderRequest.css";

function LiveOrderRequest({
    order,
    onAccept,
    onReject,
}) {

    // =====================================
    // Prevent Crash
    // =====================================

   

    const [seconds, setSeconds] = useState(30);

    useEffect(() => {

        const timer = setInterval(() => {

            setSeconds((previous) => {

                if (previous <= 1) {

                    clearInterval(timer);

                    return 0;

                }

                return previous - 1;

            });

        }, 1000);

        return () => clearInterval(timer);

    }, []);

     if (!order) {
        return null;
    }

    return (

        <div className="live-order-card">

            {/* Header */}

            <div className="live-order-header">

                <div className="store-info">

                    <Store size={22} />

                    <div>

                        <h2>

                            {order?.providerSnapshot?.businessName || "Business"}

                        </h2>

                        <p>

                            Order #

                            {" "}

                            {order?.orderNumber || "-"}

                        </p>

                    </div>

                </div>

                <div className="countdown">

                    <Clock3 size={16} />

                    {seconds}s

                </div>

            </div>

            {/* Pickup & Drop */}

            <div className="location-box">

                <div className="location-row">

                    <MapPin size={18} />

                    <div>

                        <strong>

                            Pickup

                        </strong>

                        <p>

                            {order?.providerSnapshot?.address || "Address unavailable"}

                        </p>

                    </div>

                </div>

                <div className="location-divider"></div>

                <div className="location-row">

                    <MapPin size={18} />

                    <div>

                        <strong>

                            Drop

                        </strong>

                        <p>

                            {order?.addressSnapshot?.addressLine1 || "-"}

                        </p>

                        <small>

                            {order?.addressSnapshot?.city || ""}

                        </small>

                    </div>

                </div>

            </div>

            {/* Summary */}

            <div className="delivery-summary">

                <div>

                    <Package size={18} />

                    {order?.items?.length || 0} Item(s)

                </div>

                <div>

                    <IndianRupee size={18} />

                    ₹

                    {order?.deliveryEarnings ??
                        order?.deliveryCharge ??
                        0}

                </div>

                <div>

                    <Bike size={18} />

                    {order?.status || "Ready"}

                </div>

            </div>

            {/* Buttons */}

            <div className="live-buttons">

                <button
                    className="reject-btn"
                    onClick={() => onReject(order?._id)}
                >

                    Reject

                </button>

                <button
                    className="accept-btn"
                    onClick={() => onAccept(order?._id)}
                >

                    Accept

                </button>

            </div>

        </div>

    );

}

export default LiveOrderRequest;